<template>
	<div id="Login">
		<el-form id="loginForm" :model="loginForm" label-width="20px" ref="loginForm" :rules="loginFormRules" v-if="isLogin">
		  <el-row>
		    <el-col :span="23">
		      <el-form-item label="" key="1" prop="username">
		        <el-input prefix-icon="el-icon-user" v-model="loginForm.username" placeholder="请输入用户名"
		          @blur="getUsertype">
		        </el-input>
		      </el-form-item>
		    </el-col>
		  </el-row>
		  <el-row style="margin-top:10px">
		    <el-col :span="23">
		      <el-form-item label="" key="3" prop="password">
		        <el-input prefix-icon="el-icon-lock" class="iconStyle" v-model="loginForm.password"
		          placeholder="请输入密码" type="password" @keyup.enter.native="login('loginForm')">
		        </el-input>
		      </el-form-item>
		    </el-col>
		  </el-row>
		  <el-row style="margin-top:10px">
		    <el-col :span="16">
		      <el-form-item label="" prop="picLyanzhengma">
		        <el-input placeholder="请输入验证码" class="yanzhengma_input" v-model="loginForm.picLyanzhengma"
		          prefix-icon="el-icon-key" @blur="validateCheck"
		          @keyup.enter.native="login('loginForm')"></el-input>
		      </el-form-item>
		    </el-col>
		    <el-col :span="1">&nbsp;
		    </el-col>
		    <el-col :span="6">
		      <el-form-item label="" prop="">
		        <img class="verification1 captcha_img" :src="captchaImg" @click="refreshCaptcha" title="点击刷新验证码" alt="验证码" />
		      </el-form-item>
		    </el-col>
		  </el-row>
		  <el-row class="buttonSubmit">
		    <el-button class="btn_login" size="small" @click.native="login('loginForm')" :loading="load">登录</el-button>
		    <div class="line"></div>
		    <el-button class="btn_regist" size="small" @click.native="regist('loginForm')" :loading="load">没有账号？点击注册</el-button>
		  </el-row>
		</el-form>
		
		<el-form ref="registerForm" :model="registerForm" label-width="20px" :rules="registerFormRules" v-if="isRegist" :loading="zcload">
		    <el-row>
		      <el-col :span="23">
		        <el-form-item label="" key="2" prop="username">
		          <el-input ref="input" prefix-icon="el-icon-mobile-phone" v-model="registerForm.username"
		            placeholder="请输入手机号">
		          </el-input>
		        </el-form-item>
		      </el-col>
		    </el-row>
		    <el-row style="margin-top:10px">
		      <el-col :span="16">
		        <el-form-item label="" prop="yanzhengma">
		          <el-input placeholder="请输入验证码" class="yanzhengma_input" v-model="registerForm.yanzhengma"
		            prefix-icon="el-icon-key" ></el-input>
		        </el-form-item>
		      </el-col>
		      <el-col :span="6">
		        <el-form-item label="" prop="">
		          <span class="code" type="button" @click="getMessageCode()" v-text="messageCodeText"
		            :disabled="mobileBtnDisabled">获取短信验证码</span>
		        </el-form-item>
		      </el-col>
		    </el-row>
		    <el-row style="margin-top:10px">
		      <el-col :span="23">
		        <el-form-item label="" key="4" prop="password">
		          <el-input prefix-icon="el-icon-lock" class="iconStyle" v-model="registerForm.password"
		            placeholder="请输入密码" type="password"></el-input>
		        </el-form-item>
		      </el-col>
		    </el-row>
		    <el-row style="margin-top:10px">
		      <el-col :span="23">
		        <el-form-item label="" prop="password1">
		          <el-input prefix-icon="el-icon-lock" class="iconStyle" v-model="registerForm.password1"
		            placeholder="确认密码" type="password">
		          </el-input>
		        </el-form-item>
		      </el-col>
		    </el-row>
		    <el-row class="buttonSubmit">
		      <el-button class="btn_login" size="small" @click.native="register('registerForm')" :loading="load">注册
		      </el-button>
		      <div class="line"></div>
		      <el-button class="btn_regist" size="small" @click.native="loginClick('loginForm')" :loading="load">已有账号？点击登录
		      </el-button>
		    </el-row>
		  </el-form>
	</div>
</template>
<script>
	var officeHandshake = null;
	import {
	  Encrypt,
	  Decrypt
	} from '@/common/js/secret.js'
	export default {
		name: "Login",
		data() {
			var validatePhone = (rule, value, callback) => {
			  if (value == "" || value == null && this.num == 0) {
			    return callback(new Error('请输入手机号'));
			  } else if (!/^1[345789]\d{9}$/.test(value)) {
			    return callback(new Error('请输入正确手机号'));
			  } else {
			    callback();
			  }
			};
			
			var validatePass2 = (rule, value, callback) => {
			  if (value == "" || value == null) {
			    return callback(new Error('请再次输入密码'));
			  } else if (value == this.registerForm.password && value != "" && value != null) {
			    callback();
			  } else {
			    return callback(new Error('两次密码输入不一致'));
			  }
			};
			return {
				isLogin:true,
				isRegist:false,
				currentUser: JSON.parse(localStorage.getItem('CURRENTUSER')),
				picLyanzhengma: '',
				//图形验证码：由后台生成，captchaKey 登录时提交后台校验
				captchaKey: '',
				captchaImg: '',
				loginForm: {
				  username: this.$parent.userName,
				  password: "",
				  picLyanzhengma: ""
				},
				//用户类型
				usertype: '',
				registerForm: {
				  usertype: "COM",
				  username: "",
				  password: "",
				  password1: "",
				  yanzhengma: "",
				},
				passWord: "",
				// registerFormRules: {
				//   reusername: [{
				//     validator: validatePhone,
				//     trigger: "blur"
				//   }],
				//   reyanzhengma: [{
				//     validator: validateYan,
				//     trigger: "blur",
				//   }],
				//   repassword: [{
				//       required: true,
				//       message: "请输入密码",
				//       trigger: "blur"
				//     },
				//     {
				//       min: 8,
				//       message: "密码最少8位"
				//     },
				//     {
				//       pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/,
				//       message: "密码必须包含数字、字母、特殊字符至少三种",
				//       trigger: "blur"
				//     }
				//   ],
				//   password1: [{
				//     validator: validatePass2,
				//     trigger: "blur"
				//   }],
				// },
				registerFormRules: {
				  username: [{
				    validator: validatePhone,
				    trigger: "blur"
				  }],
				  yanzhengma: [{
              required: true,
              message: "请输入验证码",
              trigger: "blur"
            },
            {
              min: 6,
              max: 6,
              message: "验证码为6位"
            }],
				  password: [{
				      required: true,
				      message: "请输入密码",
				      trigger: "blur"
				    },
				    {
				      min: 8,
				      message: "密码最少8位"
				    },
				    {
				      pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/,
				      message: "密码必须包含数字、字母、特殊字符至少三种",
				      trigger: "blur"
				    }
				  ],
				  password1: [{
				    validator: validatePass2,
				    trigger: "blur"
				  }],
				},
				messageCodeText: "获取验证码",
				mobileBtnDisabled: false,
				time: 60,
				num: 0,
				zcload: false,
				load: false,
				loginFormRules: {
				  username: [{
				    required: true,
				    message: "请输入用户名",
				    trigger: "blur"
				  }],
				  password: [{
				    required: true,
				    message: "请输入密码",
				    trigger: "blur"
				  }],
				  picLyanzhengma: [
            { validator: (rule, value, callback) => {
                if(this.usertype == "GLY"){
                  callback();
                }else{
                  if(value == null || value == ""){
                    callback(new Error("请输入验证码"));
                  }else{
                    callback();
                  }
                }
              },
              trigger: "blur"
            }
          ]
				},
			}
		},
		created() {},
		mounted() {
			this.initPostmate()
			this.refreshCaptcha()
		},
		methods: {
			//验证码校验：仅做非空提示，正确性由后台校验
      validateCheck() {
        if (this.loginForm.picLyanzhengma == null || this.loginForm.picLyanzhengma == '') {
          return false;
        }
        return true;
      },
      // 从后台获取图形验证码（key + 图片base64）
      refreshCaptcha() {
        let vm = this;
        vm.$axios.get('/captcha/generate').then(function(res) {
          if (res.data.code == '00000000' && res.data.result) {
            vm.captchaKey = res.data.result.captchaKey;
            vm.captchaImg = res.data.result.captchaImg;
            vm.loginForm.picLyanzhengma = '';
          }
        }.bind(vm), function(error) {
          console.log(error);
        });
      },
      //获取用户类型
      getUsertype() {
        let vm = this;
        if (vm.loginForm.username != "" && (vm.usertype == null || vm.usertype == "")) {
          vm.$axios.get('/account/doFindUsertype/' + vm.loginForm.username).then(function(res) {
            if (res.data.result != null) {
              if (res.data.result.usertype == null || res.data.result.usertype == "") {
                vm.usertype = "GLY";
              } else {
                vm.usertype = res.data.result.usertype;
              }
            }
          }.bind(this), function(error) {
            console.log(error)
          })
        }
      },
      initPostmate() {
      	if(officeHandshake) {
      		officeHandshake.destroy();
      		officeHandshake = null;
      	}
      	const me = this;
        let url = window.config.frontUrl + "#/loginNoPage"
      	const postmate = new Postmate({
      		container: document.getElementById("some-div"),
      		url: url
      	});
      	postmate.then(handshake => {
      		officeHandshake = handshake;
      		//绑定事件
      		//handshake.on("login", me.getFileId.bind(me));
      	});
      },
      //登录
      login: function(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let vm = this;
            var params = {
              username: vm.loginForm.username,
              password: Encrypt(vm.loginForm.password),
              captchaKey: vm.captchaKey,
              validateCode: vm.loginForm.picLyanzhengma
            }
            vm.$axios.post('/login', params).then(function(res) {
              if (res.data.code == '00000000') {
                localStorage.removeItem('isLogin');
                localStorage.removeItem('XTOKEN');
                localStorage.removeItem('CURRENTUSER');
                localStorage.setItem('isLogin', 'TRUE');
                localStorage.setItem('XTOKEN', res.data.result.token);
                localStorage.setItem('CURRENTUSER', JSON.stringify(res.data.result.currentUser));
                this.CONSTANT.currentUser = res.data.result.currentUser;

                if(officeHandshake){
                  let data = {}
                  data.isLogin = 'TRUE'
                  data.XTOKEN = res.data.result.token
                  data.CURRENTUSER = res.data.result.currentUser
									data.url = this.$parent.$parent.url
                  officeHandshake.call("login", data);
									this.$parent.$parent.LoginFormVisible = false
									this.$router.go(0)
                }else{
                  this.$message.error("同步中国消防协会会员管理系统账户失败！");
                }


              } else if (res.data.code == '77777777') {
                this.$message.error("验证码错误或已过期");
                this.refreshCaptcha();
              } else if (res.data.code == '22222222') {
                this.$message.error("账号不存在");
                this.refreshCaptcha();
              } else if (res.data.code == '33333333') {
                this.$message.error("密码不正确");
                this.refreshCaptcha();
              } else {
                this.$message.error("登录失败");
                this.$router.push({
                  path: '/'
                });
              }
            }.bind(this), function(error) {
              console.log(error)
            })
          } else {
            console.log("error save!!");
            return false;
          }
        });
      },
      regist: function() {
				this.isLogin = false
				this.isRegist = true
				this.$parent.$parent.dialogtitle = "用户注册"
      },

      loginClick: function() {
        this.isLogin = true
				this.isRegist = false
				this.$parent.$parent.dialogtitle = "用户登录"
      },

      register: function(formName) {
        this.passWord = this.registerForm.password;
        this.$refs[formName].validate(valid => {
          let vm = this;
          if (valid) {
            vm.zcload = true;
            var params = {
              username: vm.registerForm.username,
              password: vm.registerForm.password,
              usertype: "APP",
              deptid: "80",
              realname: vm.registerForm.yanzhengma
            };
            vm.$axios.post("/signin/insertByVO", params).then(function(res) {
                vm.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    if(res.data.code == "00000000"){
                      this.$refs[formName].resetFields();
                      this.isLogin = true;
                      this.isRegist = false;
                    }
                  }
                });
                vm.zcload = false;
              }.bind(vm),function(error) {
                console.log(error);
              }
            );
          }
        });
      },
      //获取手机验证码
      getMessageCode: function() {
				if(this.mobileBtnDisabled != true){
					this.$nextTick(() => { //自动获取焦点 element组件autofocus失效
					  this.$refs.input.$refs.input.focus()
					})
					if (this.registerForm.username == "" || this.registerForm.username == null) {
					  this.$nextTick(() => { //自动获取焦点 element组件autofocus失效
					    this.$refs.input.$refs.input.blur()
					  })
					} else {
					  let vm = this;
					  vm.messageCode = "";
						
					  if (vm.mobileCheck()) {
					    vm.messageCodeText = "发送中...";
					    vm.mobileBtnDisabled = true;
					    vm.$axios.get("/signin/getUsernameNum/" + vm.registerForm.username + "/static").then(function(res) {
					        if (res.data.result != 0) {
					          this.$alert('用户名已存在', '提示', {
					            confirmButtonText: '确定',
					            callback: action => {
					              vm.messageCodeText = "获取验证码";
					              vm.mobileBtnDisabled = false;
					            }
					          });
					
					        } else {
					          vm.$axios.get("/signin/sendMessage?phone=" + vm.registerForm.username+"register").then(function(res) {
                        if(res.data.code == "00000000"){
                          var count = vm.time;
                          vm.timer = setInterval(() => {
                            if (count == 0) {
                              clearInterval(vm.timer);
                              vm.timer = null;
                              vm.messageCodeText = "获取验证码";
                              vm.mobileBtnDisabled = false;
                            } else {
                              vm.messageCodeText = count + "秒后获取";
                              count--;
                              vm.mobileBtnDisabled = true;
                              
                            }
                          }, 1000);
                        }else{
                          this.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                              vm.messageCodeText = "获取验证码";
                              vm.mobileBtnDisabled = false;
                            }
                          });
                        }
					            }.bind(vm),function(error) {
					              console.log(error);
					            }
					          );
					        }
					      }.bind(vm),function(error) {
					        console.log(error);
					      }
					    );
				}
          }
        }
      },
      mobileCheck() {
        var name = "";
        if (this.registerForm.username != null && this.registerForm.username != "") {
          name = this.registerForm.username;
        }
        if (!/^1[345789]\d{9}$/.test(name)) {
          //用户名不正确，显示红字提醒
          this.usernameAlertFlag = true;
          return false;
        } else {
          this.usernameAlertFlag = false;
          return true;
        }
      },
		},

	};
</script>
<style scoped lang="scss">
	#Login {
		.captcha_img{
			height: 40px;
			cursor: pointer;
			border-radius: 4px;
			border: 1px solid #dcdfe6;
			object-fit: cover;
		}
		width: 400px;
		.el-form{
			width: 460px;
		}
.loginbox {
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #ffffff;
      color: #1243cb;
      margin-left: 40px;
      border-radius: 20px;
      font-size: 14px;
    }

    .loginbox img {
      display: inline-block;
      vertical-align: middle;
      margin-top: -1px;
    }

    .logintxt {
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
      margin-top: -1px;
    }


    .login-btn {
      width: 100%;
      margin-top: 20px;
    }

    .buttonSubmit {
      margin-top: 10px;
      padding: 0 20px;
    }

    .el-button {
      width: 100%;
      height: 40px;
    }

    .btn_login {
      background-color: #1243cb;
      color: #ffffff;
      font-size: 16px;
    }

    .btn_regist {
      margin-top: 20px;
      color: #1243cb;
      font-size: 16px;
      border: 1px solid #1243cb;
    }

    .line {
      margin-top: 20px;
      width: 100%;
      height: 2px;
      background-color: #DDDDDD;
    }

    .el-form-item__error {
      margin-top: 5px;
    }

    .verification1 {
      width: 7.125rem;
      height: 40px;
      border: none;
      border-radius: .3125rem;
      font-size: 1.75rem;
      color: #F89E19;
      font-family: 'PingFangRegular';
      text-shadow: 0.05em 0.05em 0.3em #333333;
      float: right;
    }

    .code {
      width: 110px;
      border: 1px solid #DDDDDD;
      text-align: center;
    }
	}
</style>



// WEBPACK FOOTER //
// src/views/portal/layout/Login.vue